module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', _vm._l((_vm.infoList), function(item) {
    return _c('el-collapse-item', {
      key: item.title,
      attrs: {
        "title": item.title,
        "descList": item.descList
      }
    }, [_vm._l((item.descList), function(desc) {
      return _c('div', {
        key: desc,
        staticClass: "collapseDesc"
      }, [_vm._v(_vm._s(desc))])
    }), _vm._t(item.name)], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e35b3b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollapseInfo/index.vue
// module id = 1760
// module chunks = 1